const addLocale = (path: string, localeToAdd: string) => {
  if (!path.startsWith(`/${localeToAdd}`)) {
    return `/${localeToAdd}${path}`
  }

  return path
}

export default addLocale
